import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_textbox_list extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_textbox_list">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Textbox List</h2>
              <p>
                Textbox lists allow you to create ordered collections of text
                fields. Textbox Lists have a flexible structure allowing for
                different sizes and types of textboxes. Textbox Lists store data
                in a text array of JSON strings.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_textbox_list"}
                name={"textbox list"}
                dataNameDefault={'"array_text_my_json_item"'}
                padding={true}
                hide={true}
                order={true}
                button={true}
                tabIndex={true}
                readOnly={true}
                onChangeEval={true}
                properties={[
                  {
                    property: "list_add_default",
                    description:
                      "Default values when use adds a new list item. (in JSON string)",
                    defaults:
                      '{"text_item_field":"Example Default"}" default is ""',
                  },
                  {
                    property: "list_add",
                    description:
                      "Allows the user to add new items to the list.",
                    defaults: "true, false default is true",
                  },
                  {
                    property: "list_layout",
                    description:
                      "Defines the layout of the list items. See below.",
                    defaults: "{ ... }",
                  },
                  {
                    property: "list_remove",
                    description:
                      "Allows the user to remove items from the list.",
                    defaults: "true, false default is true",
                  },
                  {
                    property: "list_reorder",
                    description:
                      "Allows the user to reorder items in the list.",
                    defaults: "true, false default is true",
                  },
                ]}
              />
              <h3>Structure "list_layout"</h3>
              <p>
                Below is a simple results list layout structure. This structure
                has two rows. The first row has one container textbox 100% wide.
                The second row has two textboxs, 25% and 75% wide.
              </p>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="b top">Example</td>
                    <td className="b top">JSON</td>
                  </tr>
                  <tr>
                    <td className="b">list_layout</td>
                    <td className="darkCode darkbackground2">
                      <div>&#123;</div>
                      <div className="i1">
                        <span className="jsonG">"containers"</span>: &#123;
                      </div>
                      <div className="i2">
                        <span className="jsonG">"top"</span>: &#123;
                      </div>
                      <div className="i3">
                        <span className="jsonG">"width"</span>:{" "}
                        <span className="jsonY">"fl100"</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"row"</span>:{" "}
                        <span className="jsonP">1</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"components"</span>: &#123;
                      </div>
                      <div className="i4">
                        <span className="jsonG">"text_item_field"</span>: &#123;
                      </div>
                      <div className="i5">
                        <span className="jsonG">"type"</span>:{" "}
                        <span className="jsonY">"list_textbox"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_name"</span>:{" "}
                        <span className="jsonY">"text_item_field"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_type"</span>:{" "}
                        <span className="jsonY">"text"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"display_name"</span>:{" "}
                        <span className="jsonY">"My Text Field"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>
                      </div>
                      <div className="i4">&#125;</div>
                      <div className="i3">&#125;</div>
                      <div className="i2">&#125;,</div>
                      <div className="i2">
                        <span className="jsonG">"bottom_left"</span>: &#123;
                      </div>
                      <div className="i3">
                        <span className="jsonG">"width"</span>:{" "}
                        <span className="jsonY">"fl25"</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"row"</span>:{" "}
                        <span className="jsonP">2</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"components"</span>: &#123;
                      </div>
                      <div className="i4">
                        <span className="jsonG">"long_number_1"</span>: &#123;
                      </div>
                      <div className="i5">
                        <span className="jsonG">"type"</span>:{" "}
                        <span className="jsonY">"list_textbox"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_name"</span>:{" "}
                        <span className="jsonY">"long_number_1"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_type"</span>:{" "}
                        <span className="jsonY">"number"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"display_name"</span>:{" "}
                        <span className="jsonY">"My Number Field"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>
                      </div>
                      <div className="i4">&#125;</div>
                      <div className="i3">&#125;</div>
                      <div className="i2">&#125;,</div>
                      <div className="i2">
                        <span className="jsonG">"bottom_right"</span>: &#123;
                      </div>
                      <div className="i3">
                        <span className="jsonG">"width"</span>:{" "}
                        <span className="jsonY">"fl75"</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"row"</span>:{" "}
                        <span className="jsonP">2</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">2</span>,
                      </div>
                      <div className="i3">
                        <span className="jsonG">"components"</span>: &#123;
                      </div>
                      <div className="i4">
                        <span className="jsonG">"description"</span>: &#123;
                      </div>
                      <div className="i4">
                        <span className="jsonG">"long_number_2"</span>: &#123;
                      </div>
                      <div className="i5">
                        <span className="jsonG">"type"</span>:{" "}
                        <span className="jsonY">"list_textbox"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_name"</span>:{" "}
                        <span className="jsonY">"long_number_2"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"data_type"</span>:{" "}
                        <span className="jsonY">"currency"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"decimals"</span>:{" "}
                        <span className="jsonP">2</span>
                      </div>
                      <div className="i5">
                        <span className="jsonG">"display_name"</span>:{" "}
                        <span className="jsonY">"My Number Field 2"</span>,
                      </div>
                      <div className="i5">
                        <span className="jsonG">"order"</span>:{" "}
                        <span className="jsonP">1</span>
                      </div>
                      <div className="i4">&#125;</div>
                      <div className="i3">&#125;</div>
                      <div className="i2">&#125;</div>
                      <div className="i1">&#125;</div>
                      <div>&#125;</div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3>List Layout Component</h3>
              <p>
                The Textbox List Textbox is a reduced version of the record
                Textbox.
              </p>
              <h3>Properties</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">data_name</td>
                    <td>
                      <i
                        className="material-icons"
                        style={{
                          display: "inline-block",
                          height: 24,
                          position: "relative",
                          top: 6,
                          fontSize: 24,
                          color: "#F57C00",
                        }}
                      >
                        warning
                      </i>
                      Field in the database bound to this component.
                      <br />
                      <i>"text_my_field", "long_my_number"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">alphanumeric</td>
                    <td>
                      Restricts user input to only alphanumeric characters.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">data_type</td>
                    <td>
                      The data type of the bound data. Default is "text".
                      "currency" and "number" will display bound value as a
                      number.
                      <br />
                      <i>"text", "currency", "date" default is "text"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">decimals</td>
                    <td>
                      Numbers including decimals are stored in the database as
                      whole numbers. This feature converts whole numbers to
                      decimals. A value of 0 will treat the value as a whole
                      number a value of 2 will divide number by 100 and show two
                      decimals. This will only work with data_type "number".
                      <br />
                      <i>0-8 default is 0</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">display_name</td>
                    <td>
                      The label name displayed to the left of the bound data.
                      <br />
                      <i>"Client", "Agent" default is ""</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">lowercase</td>
                    <td>
                      Changes user input to lowercase.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">no_space</td>
                    <td>
                      Stops the user from entering an space.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      The left to right order that the labels will be displayed.
                      <br />
                      <i>1 - 10000 default is 1</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">regex</td>
                    <td>
                      Test user input against a regular expression. Be aware
                      that some regular expressions use JSON escape characters.
                      You will need to replace a backslash with a double
                      backslash.
                      <br />
                      <i>"regular expression"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">regex_failed_message</td>
                    <td>
                      Message displyed if users input fails a regular
                      expression.
                      <br />
                      <i>"Failed regular expression check."</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">uppercase</td>
                    <td>
                      Changes user input to uppercase.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Textbox List Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Texbox List</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_textbox_list"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"array_text_my_field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"button_position"</span>:{" "}
                  <span className="jsonY">"right"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"list_add_default"</span>:{" "}
                  <span className="jsonY">
                    {'"{"text_item_field":"Example Default"}"'}
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"list_add"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"list_reorder"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"list_remove"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"tab_index"</span>:{" "}
                  <span className="jsonP">10</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"hide"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"list_layout"</span>:{" "}
                  <span>{"{ ... }"}</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_textbox_list;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_textbox_list.js